@if (singleActions.length > 0) {
  <button
    mat-icon-button
    type="button"
    class="operations-menu-button tw-w-[32px] tw-h-[32px] hover:tw-bg-gray-200 tw-rounded-md"
    [class.menu-is-open]="matMenuTrigger?.menuOpen ?? false"
    [matMenuTriggerFor]="menu"
    #matMenuTrigger="matMenuTrigger"
    (click)="$event.stopPropagation()"
    [id]="id + '-button'"
    aria-label="Operations menu"
  >
    <div class="tw-flex tw-items-center tw-justify-center">
      <mat-icon
        svgIcon="more-vertical"
        class="tw-cursor-pointer tw-rotate-90 tw-text-gray-800"
      />
    </div>
  </button>
}

<mat-menu
  #menu="matMenu"
  classList="operations-menu"
  aria-label="Operations menu"
>
  @for (operation of singleActions; track operation.name) {
    @if (
      operation.singleSeparatorBefore || operation.isDelete || operation.danger
    ) {
      <rv-divider class="tw-my-[8px]" />
    }
    @if (operation.submenu && submenuActions(operation).length > 0) {
      <button
        mat-menu-item
        *requireRole="operation.requireRole"
        type="button"
        [matMenuTriggerFor]="submenu"
        [id]="'action' + operation.name.split(' ').join('')"
        class="operations-menu-item"
      >
        <mat-icon class="default" [svgIcon]="getOperationIcon(operation)" />
        <span>{{ operation.singleLabel ?? operation.name }}</span>
      </button>
      <mat-menu #submenu="matMenu" classList="operations-menu">
        @for (child of submenuActions(operation); track $index) {
          @if (child.separator) {
            <rv-divider class="tw-my-[8px]" />
          } @else {
            <button
              mat-menu-item
              *requireRole="child.requireRole"
              type="button"
              [class.tw-text-red-700]="child.isDelete || child.danger"
              (click)="handleClick(child.name)"
              [id]="'action' + child.name.split(' ').join('')"
              class="operations-menu-item"
              [ngClass]="{ 'rise-admin-only': child.requireRole === 'sa' }"
            >
              <mat-icon class="default" [svgIcon]="getOperationIcon(child)" />
              <span>{{ child.singleLabel ?? child.name }}</span>
              @if (getUpgradeIcon(child); as upgradeIcon) {
                <mat-icon class="small" [svgIcon]="upgradeIcon" />
              }
            </button>
          }
        }
      </mat-menu>
    } @else if (!operation.submenu) {
      <button
        mat-menu-item
        *requireRole="operation.requireRole"
        type="button"
        [class.tw-text-red-700]="operation.isDelete || operation.danger"
        (click)="handleClick(operation.name)"
        [id]="'action' + operation.name.split(' ').join('')"
        class="operations-menu-item"
        [ngClass]="{ 'rise-admin-only': operation.requireRole === 'sa' }"
      >
        <mat-icon class="default" [svgIcon]="getOperationIcon(operation)" />
        <span>{{ operation.singleLabel ?? operation.name }}</span>
        @if (getUpgradeIcon(operation); as upgradeIcon) {
          <mat-icon class="small" [svgIcon]="upgradeIcon" />
        }
      </button>
    }
  }
</mat-menu>
